<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex align-items-start justify-content-between">
        <back-arrow :title="technician.name"/>
        <show-actions
            @clickOnEditBtn="clickOnEditBtn"
            @clickOnDeleteBtn="clickOnDeleteBtn"
        >
          <button class="show-action-btn mr-1" @click="clickOnResetPassword">
            <mail-icon size="18"/>
            Changer le mot de passe
          </button>
        </show-actions>
      </div>
      <b-card class="mt-2 mb-4 shadow-sm">
        <div class="row">

          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('technician.FirstName') }}
            </div>
            <div>
              {{ getValue("firstName") }}
            </div>
          </div>

          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('technician.LastName') }}
            </div>
            <div>
              {{ getValue("lastName") }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('technician.Email') }}
            </div>
            <div>
              <b-link :href="'mailto:'+getValue('username')">{{ getValue('username') }}</b-link>
            </div>
          </div>

          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('technician.PhoneNumber') }}
            </div>
            <div>
              {{ getValue("phoneNumber") }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-6 mb-2">
            <div class="bold-text label-color">
              {{ $t('technician.GoogleAgendaLink') }}
            </div>
            <div>
              {{ getValue("googleAgendaLink") }}
            </div>
          </div>

        </div>
      </b-card>
    </b-container>
    <!-- Modal Reset Password -->
    <reset-password-modal v-if="ui.selectedTechnician" :selectedUser="ui.selectedTechnician" @didSendResetPassword="didSendResetPassword()"></reset-password-modal>

    <!-- Modal Delete -->
    <technician-delete-modal :selectedTechnician="technician" @didDeleteTechnician="didDeleteTechnician()"></technician-delete-modal>
  </div>
</template>

<script>
import api from '../../services/api';
import BackArrow from "../../components/b122/BackArrow";
import ShowActions from "../../components/b122/ShowActions";
import B122Table from "../../components/b122/B122Table";
import TechnicianDeleteModal from "./TechnicianDeleteModal";
import ResetPasswordModal from "../../components/ResetPasswordModal";

export default {

  name: 'TechnicianShow',

  components: {
    BackArrow,
    ShowActions,
    B122Table,
    TechnicianDeleteModal,
    ResetPasswordModal
  },

  data() {
    return {
      technicianId: this.$route.params.technicianId,
      technician: {},
      ui: {
        selectedTechnician: null
      }
    }
  },

  computed: {
    getValue() {
      return property => (this.technician[property] || this.technician[property] == false) ? this.technician[property] : "N/A"
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.fetchTechnician()
    },

    fetchTechnician() {
      api
          .get(`/technician/${this.technicianId}`)
          .then(response => {
            this.technician = response.data
          })
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'TechnicianEdit',
        params: {
          technicianId: this.technician.id
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('technician-delete-modal')
    },

    didDeleteTechnician() {
      this.$router.push({
        name: 'TechnicianIndex'
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.$i18n.t('Technician') + ' "' + this.technician.name + '" ' + this.$i18n.t('deleted'))
        })
      })
    },
    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },

    clickOnResetPassword() {
      this.ui.selectedTechnician = this.technician
      this.$bvModal.show('reset-password-modal')
    },

    didSendResetPassword() {
      this.ui.selectedTechnician = null
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/TechnicianShow.vue